module.exports = __webpack_public_path__ + "h5/img/mask_img3.46836c9b.png";